import React from 'react';
import { Header } from './components/Header';
import { StorySection } from './components/StorySection';
import { DanderInfo } from './components/DanderInfo';
import { SolutionsComparison } from './components/SolutionsComparison';
import { ProductInfo } from './components/ProductInfo';
import { Testimonials } from './components/Testimonials';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { ClarityScript } from './components/ClarityScript';
import { MetaPixelScript } from './components/MetaPixelScript';
export function App() {
  return <div className="w-full bg-white text-gray-800" data-id="element-0">
      <ClarityScript data-id="element-1" />
      <MetaPixelScript data-id="element-2" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3">
        <Header data-id="element-4" />
        <StorySection data-id="element-5" />
        <DanderInfo data-id="element-6" />
        <SolutionsComparison data-id="element-7" />
        <ProductInfo data-id="element-8" />
        <Testimonials data-id="element-9" />
        <PricingSection data-id="element-10" />
        <Footer data-id="element-11" />
      </div>
    </div>;
}